import {PatientSurveyProps, SurveyComponentTypes} from '../../types';
import {parseJSON} from '../../../../helpers';
import {TextField} from '../../../common/formik/fields';
import {FormGroup} from '@mui/material';

type TextFieldComponentProps = {
  data: PatientSurveyProps;
  disabled: boolean;
}

const TextFieldComponent = ({data, disabled}: TextFieldComponentProps) => {
  const {type, label, details, id, required, answer = ''} = data;

  const {placeholder} = parseJSON(details) || '';

  if (![
    SurveyComponentTypes.TEXT,
    SurveyComponentTypes.TEXTAREA
  ].includes(type)) {
    return null;
  }

  const isMultiline = type === SurveyComponentTypes.TEXTAREA;

  return (
    <FormGroup className="text-field">
      <TextField
        name={`${id}`}
        label={label}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        defaultValue={answer}
        showErrorMessage
        multiline={isMultiline}
      />
    </FormGroup>

  );
};

export default TextFieldComponent;
